<template >
<v-container >
  <v-layout justify-centerv-if="overlay">
       <v-dialog v-model="overlay" persistent max-width="600">
         <v-card>
           <v-card-text>
              <v-progress-linear
                indeterminate
                color="blue"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
    </v-layout>
    <v-card>
      <v-container>
      <v-form ref="form" v-model="valid" lazy-validation >
        <v-layout justify-center>
      <v-dialog v-model="erroreValidazione" persistent max-width="400">
        <v-card>
          <v-card-title class="headline">ATTENZIONE</v-card-title>
          <v-card-text>Gentile utente,<br><br>
            - inserire almeno le date di interesse o, alternativamente: anno, filiale di competenza e progressivo spedizione.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="erroreValidazione = false">OK</v-btn>
            
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
        <h1>Elenco spedizioni:</h1><h4>(utilizza i filtri per ricercare le spedizioni)</h4>
        <v-layout row wrap>
          <v-flex xs12 sm6 md4>
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="data_partenza"
              persistent
              lazy
              full-width
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="data_partenza"
                  label="Da data: "
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker locale="it-IT" v-model="data_partenza" scrollable :min="minPartenza" :max="maxPartenza">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal = false">Annulla</v-btn>
                <v-btn flat color="primary" @click="checkFinale">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md4>
            <v-dialog
              ref="dialog2"
              v-model="modal2"
              :return-value.sync="data_finale"
              persistent
              lazy
              full-width
              width="290px"
            >
              <v-spacer></v-spacer>
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="data_finale"
                  label="A data: "
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker locale="it-IT" v-model="data_finale" scrollable :min="minFinale" :max="maxFinale">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="modal2 = false">Annulla</v-btn>
                <v-btn flat color="primary" @click="$refs.dialog2.save(data_finale)">OK</v-btn>
              </v-date-picker>
            </v-dialog>
          </v-flex>
          <template
            slot="pageText"
            slot-scope="{ pageStart, pageStop }"
          >From {{ pageStart }} to {{ pageStop }}</template>
          <v-spacer></v-spacer>
          <v-flex xs0 sm0 md3>
            
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm12 md4>
            <v-text-field label="Rag. Soc. Destinatario" v-model="rag_destinatario"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md4>
            <v-text-field label="Località destino" v-model="localita_dest"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3>
            <v-text-field label="Provincia destino" v-model="provincia_dest"></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md4>
          <v-text-field label="Riferimento mittente" v-model="numero_ddt"></v-text-field>
          </v-flex>
          <v-flex xs0 sm0 md4>
          </v-flex>
          <v-flex xs0 sm0 md4>
          </v-flex>
          <v-flex xs0 sm0 md4>
          <v-select
            v-bind:items="stato"
            v-model="Stati"
            label="Stato spedizioni"
            @change="GetStati"
          ></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md4>
          <v-select
            v-bind:items="porto"
            v-model="porti"
            label="Porto"
            @change="GetPorto"
          ></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md3>
          <v-select
            v-bind:items="nazioni"
            v-model="nazione"
            label="Italia / Estero"
            @change="GetNazioni"
          ></v-select>
          </v-flex>
          
          <v-spacer></v-spacer>
          </v-layout>
          <v-layout row wrap>
          <v-flex xs12 sm6 md1>
            <v-text-field label="Anno" v-model="annoSpe" maxlength='4'></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md1>
            <v-text-field label="Filiale" v-model="filialeSpe" maxlength='3'></v-text-field>
          </v-flex>
          <v-flex xs12 sm6 md2>
            <v-text-field label="Numero Spedizione" v-model="Spe" maxlength='8'></v-text-field>
          </v-flex>
          <v-spacer></v-spacer>
         
            
          
          
          <v-spacer></v-spacer>
          
          
          <!-- <v-flex xs12 sm6 md4>
            <v-text-field label="Numero Spedizione" v-model="numero_sped" maxlength='15' :hidden="true"></v-text-field>
          </v-flex> -->
          <v-spacer></v-spacer>
          
        <v-spacer></v-spacer>
        </v-layout>
        <v-btn @click="validate">Cerca</v-btn>
        <v-btn @click="EstraiCSV">Estrazione dati</v-btn>
        <v-btn @click="formReset">Reset campi</v-btn>
  
        <v-card-text>
          <strong>Spedizioni trovate: {{ itemsVisualizzati.length }}</strong> 
          <v-progress-circular v-if="carica"
          class="text-center"
          indeterminate
          color="primary"
    ></v-progress-circular>
          <v-spacer></v-spacer>
          
          <!-- <v-text-field append-icon="search" label="Cerca" single-line hide-details v-model="search"></v-text-field> -->
        </v-card-text>
        </v-form>

        <v-data-table
          v-bind:headers="headers"
          v-bind:items="this.itemsVisualizzati"
          v-bind:search="search"
          disable-initial-sort
          :pagination.sync="pagination"
        >
          <template slot="items" slot-scope="props">
            <tr @click="updateRecord(props.item.codiceSpedizione)">
              <td class="text-xs-left">{{ props.item.dataSpedizione }}</td>
              <td class="text-xs-left" style="background-color: #F4F4F4">{{ props.item.noteStato }}</td>
              <td class="text-xs-left">{{ props.item.codiceVisualizzato }}</td>
              <td class="text-xs-left">{{ props.item.riferimentoCliente }}</td>
              <td class="text-xs-left">{{ props.item.ragioneSocialeDestinatario }}</td>
              <td class="text-xs-left">{{ props.item.volume }}</td>
              <td class="text-xs-left">{{ props.item.volumeRil }}</td>
              <td class="text-xs-left">{{ props.item.peso }}</td>
              <td class="text-xs-left">{{ props.item.pesoRil }}</td>
            </tr>
          </template>
          <template
            slot="pageText"
            slot-scope="{ pageStart, pageStop }"
          >From {{ pageStart }} to {{ pageStop }}</template>
        </v-data-table>
        </v-container>
    </v-card>
</v-container>
</template>


<script>

import axios from "axios";
export default {
 
  data: () => ({
    overlay: false,
    valid: false,
    errore: false,
    erroreDimensione: false,
    acquista: false,
     mask: '###############',
    maxLenSpe: 15,
    pagination: { rowsPerPage: 25 },
    valid: true,
    carica: false,
    cutstring: [],
    erroreValidazione: false,
    nazioneSelezionata: "TUTTI",
    statoSelezionato: "TUTTI",
    portoSelezionato: "TUTTI",
    nazione: {value: "TUTTI", text: "TUTTI"},
    nazioni: [
      {value: "TUTTI", text: "TUTTI"},
      {value: "E", text: "ESTERO"},
      {value: "I", text: "ITALIA"},
    ],
    stato: [{value: "TUTTI", text: "TUTTI"}],
    Stati: {value: "TUTTI", text: "TUTTI"},
    porto: [
      {value: "TUTTI", text: "TUTTI"},
      {value: "F", text: "FRANCO"},
      {value: "A", text: "ASSEGNATO"},
      {value: "T", text: "TRIANGOLAZIONE"},
    ],
    porti: {value: "TUTTI", text: "TUTTI"},
    data_partenza: "",
    data_finale: "",
    modal: false,
    modal2: false,
    numero_ddt: null,
    rag_destinatario: null,
    localita_dest: null,
    provincia_dest: null,
    search: "",
    numero_sped: null,
    minPartenza: "01-01-2000",
    maxPartenza: "01-01-2000",
    minFinale: "00-00-0000",
    maxFinale: "00-00-0000",
    valoreStatoSelezionato: "",
    valorePortoSelezionato: "",
    headers: [
      { text: "Data Spedizione", align: "left", value: "dataSpedizione" },
      { text: "Stato", align: "left", value: "noteStato" },
      { text: "Numero spedizione", align: "left", value: "codiceSpedizione" },
      { text: "Rif. cliente", align: "left", value: "riferimentoCliente" },
      { text: "Ragione sociale destinatario", align: "left", value: "ragioneSocialeDestinatario" },
      { text: "Volume", align: "left", value: "volume" },
      { text: "Volume ril.", align: "left", value: "volumeRil" },
      { text: "Peso", align: "left", value: "peso" },
      { text: "Peso ril.", align: "left", value: "pesoRil" }
    ],
    items: [],
    itemsVisualizzati: [],
    annoSpe: "",
    filialeSpe: "",
    Spe: "",
    variazioni: [],

  }),
  mounted() {
    this.overlay = true;
    this.annoSpe = new Date().toISOString().substr(0, 4);
    axios.get(this.$store.state.servicePath + "/api/ArVwVariazioniRullieras/Differenze" ,{})
            .then(res=>{
              res.data.forEach(el =>{
                
                if(el.codiceSpedizione in this.variazioni){
                  this.variazioni[el.codiceSpedizione] = el;
                }
                else{
                  this.variazioni[el.codiceSpedizione] = [];
                  this.variazioni[el.codiceSpedizione] = el;
                }
              });
              this.overlay = false;
              
              
            });
    window.addEventListener("keypress", e => {
      if(e.keyCode === 13)
        this.validate()
		//console.log(String.fromCharCode(e.keyCode));
	  });
    this.CheckJWT();
    this.CaricaStati();
    if (this.$store.state.filtri_PesiVolumi.data_partenza || this.$store.state.filtri_PesiVolumi.numero_sped) {
      this.data_partenza = this.$store.state.filtri_PesiVolumi.data_partenza;
      this.minPartenza = this.$store.state.filtri_PesiVolumi.minPartenza;
      this.maxPartenza = this.$store.state.filtri_PesiVolumi.maxPartenza;
      this.data_finale = this.$store.state.filtri_PesiVolumi.data_finale;
      this.numero_ddt = this.$store.state.filtri_PesiVolumi.numero_ddt;
      this.rag_destinatario = this.$store.state.filtri_PesiVolumi.rag_destinatario;
      this.localita_dest = this.$store.state.filtri_PesiVolumi.localita_dest;
      this.provincia_dest = this.$store.state.filtri_PesiVolumi.provincia_dest;
      this.numero_sped = this.$store.state.filtri_PesiVolumi.numero_sped;
      this.annoSpe = this.numero_sped.substr(0,4);
      this.filialeSpe = this.numero_sped.substr(4,3);
      this.Spe = this.numero_sped.substr(7,8);
      this.minFinale = this.$store.state.filtri_PesiVolumi.minFinale;
      this.maxFinale = this.$store.state.filtri_PesiVolumi.maxFinale;
      this.statoSelezionato = this.$store.state.filtri_PesiVolumi.statoSelezionato;
      this.portoSelezionato = this.$store.state.filtri_PesiVolumi.portoSelezionato;
      this.Stati= {value: this.statoSelezionato};
      this.porti= {value: this.portoSelezionato};
      this.itemsVisualizzati = this.$store.state.items_PesiVolumi;
      this.nazioneSelezionata = this.$store.state.filtri_PesiVolumi.nazione
      this.nazione ={value: this.nazioneSelezionata};
      //this.effettuaRicerca();
    } else {
      // this.data_partenza = this.addDays(new Date(), -7)
      //   .toISOString()
      //   .substr(0, 10);
      this.minPartenza = this.addDays(new Date(), -365)
        .toISOString()
        .substr(0, 10);
      this.maxPartenza = new Date().toISOString().substr(0, 10);
      this.annoSpe = new Date().toISOString().substr(0, 4);
      this.filialeSpe = "";
      this.Spe = "";
      // this.data_finale = new Date().toISOString().substr(0, 10);
      this.numero_ddt = null;
      this.rag_destinatario = null;
      this.localita_dest = null;
      this.provincia_dest = null;
      this.numero_sped = "";
      this.minFinale = this.data_partenza;
      this.maxFinale = new Date().toISOString().substr(0, 10);
    }
  },
  methods: {
    allowedDates: val => el.indexOf(val) !== -1,
    checkFinale() {
      this.$refs.dialog.save(this.data_partenza);
      this.minFinale = this.data_partenza;
      this.maxFinale = new Date().toISOString().substr(0, 10);
    },
    validate() {
      if(this.annoSpe === "" || this.annoSpe === undefined){
        this.annoSpe = new Date().toISOString().substr(0, 4);
      }
      if(this.filialeSpe === "" || this.filialeSpe === undefined){
        this.filialeSpe = "000"
      }
      if(this.annoSpe.length === 2){
        this.annoSpe = "20"+ this.annoSpe;
      }
      if(this.Spe === "" || this.Spe === undefined){
        this.Spe = "00000000"
      }
      var padFil = "000";
      var fil = padFil.substring(0, padFil.length - this.filialeSpe.length) + this.filialeSpe;
      var pad = "00000000";
      var numero = pad.substring(0, pad.length - this.Spe.length) + this.Spe;
      this.numero_sped = this.annoSpe + fil + numero;
      if(this.numero_sped === "00000000000" || this.numero_sped === "000000000000000" || this.numero_sped.includes("00000000")){
        this.numero_sped = "";
        this.annoSpe = new Date().toISOString().substr(0, 4);
        this.filialeSpe = "";
        this.Spe = "";
      }
      
      if (this.$refs.form.validate() && ((this.data_partenza !== "" && this.data_partenza !== undefined && this.data_partenza !== null && this.data_finale !== "" && this.data_finale !== undefined && this.data_finale !==null) || (this.numero_sped !== "" && this.numero_sped !== undefined && this.numero_sped !== null && this.numero_sped.length > 14))) {
        this.Cerca();
      }
      else{
        this.erroreValidazione = true
      }
    },
    addDays(date, days) {
      date.setDate(date.getDate() + days);
      return date;
    },
    CaricaStati(){
      axios
        .get(this.$store.state.servicePath + "/api/ArStatiSpediziones", {
        })
        .then(res => {
          res.data.forEach(element =>{
            this.el ={value : element.codice, text: element.descrizione}
            this.el2 = {"key":element.codice, "value":element.cutString}
            this.stato.push(this.el)
            this.cutstring.push(this.el2)
          })
          });
    },
    Cerca() {
      var filtri = {};
      filtri.data_partenza = this.data_partenza;
      filtri.minPartenza = this.minPartenza;
      filtri.maxPartenza = this.maxPartenza;
      filtri.data_finale = this.data_finale;
      filtri.numero_ddt = this.numero_ddt;
      filtri.rag_destinatario = this.rag_destinatario;
      filtri.localita_dest = this.localita_dest;
      filtri.provincia_dest = this.provincia_dest;
      filtri.numero_sped = this.numero_sped;
      filtri.minFinale = this.minFinale;
      filtri.maxFinale = this.maxFinale;
      filtri.statoSelezionato = this.statoSelezionato;
      filtri.valoreStatoSelezionato = this.valoreStatoSelezionato;
      filtri.portoSelezionato = this.portoSelezionato;
      filtri.valorePortoSelezionato = this.valorePortoSelezionato
      filtri.nazione = this.nazioneSelezionata
      

      this.$store.commit("setFiltriPesiVolumi", filtri);
      this.effettuaRicerca();
    },
    effettuaRicerca() {
      this.loading = true
      this.carica = true
      axios
        .post(this.$store.state.servicePath + "/api/ArTrackings/GetTracking", {
          dataPartenza: this.data_partenza,
          dataFinale: this.data_finale,
          numeroDdt: this.numero_ddt,
          ragioneSocialeDestinatario: this.rag_destinatario,
          localitaDestino: this.localita_dest,
          provinciaDestino: this.provincia_dest,
          NumeroSpedizione: this.numero_sped,
          Porto: this.portoSelezionato,
          statoSpedizione: this.statoSelezionato,
          nazioneDestinatario: this.nazioneSelezionata
          // codice: this.$store.state.token
        })
        .then(res => {
          this.items = res.data;
          this.itemsVisualizzati = [];
          console.log(this.variazioni);
          this.items.forEach(el=>{
            if(el.codiceSpedizione in this.variazioni){
              var element = {
                dataSpedizione: el.dataSpedizione,
                ultimoStato: el.ultimoStato,
                noteStato: el.noteStato,
                codiceSpedizione: el.codiceSpedizione,
                riferimentoCliente: el.riferimentoCliente,
                ragioneSocialeDestinatario: el.ragioneSocialeDestinatario,
                localitaDestinatario: el.localitaDestinatario,
                provinciaDestinatario: el.provinciaDestinatario,
                codiceVisualizzato: el.codiceSpedizione.substr(0,4) + "-" + el.codiceSpedizione.substr(4,3) + "-" + el.codiceSpedizione.substr(7,8),
                peso: Number(this.variazioni[el.codiceSpedizione].trvpep) / 10,
                pesoRil: Number(this.variazioni[el.codiceSpedizione].trvper) / 10,
                volume: Number(this.variazioni[el.codiceSpedizione].trvvop) / 100,
                volumeRil: Number(this.variazioni[el.codiceSpedizione].trvvor) / 100,
              // pesoRil: Number(res.data.)
            }
            this.itemsVisualizzati.push(element);
          }
          })
            this.$store.commit("setItemsPesiVolumi", this.itemsVisualizzati);
            this.carica = false
            this.loading = false
          });
          
        
    },
    updateRecord(Nservizio) {
      this.$router.push({ path: `/PesiVolumi/${Nservizio}` });
    },
    CheckJWT() {
      axios
        .post(this.$store.state.servicePath + "/api/Login/checkJwt", {
          route: this.$route.path
        })
        .then(res => {
          if (res.data.status == "ko") {
            this.$router.push({ path: `/errore` });
          }
        })
        .catch(err =>{
          this.$router.push({ path: `/errore` });
        });
    },
    GetStati(value){
      this.statoSelezionato = value
    },
    GetPorto(value){
      this.portoSelezionato = value
    },
    GetNazioni(value){
      this.nazioneSelezionata = value
    },
    EstraiCSV() {
      var dati = []
      var intestazione = ['Numero spedizione', 'Data spedizione', 'Codice cliente', 'Ultimo stato', 'Data ultimo stato',
							'Num DDT', 'Rag. Soc. Mitt.', 'Ind. Mitt.', 'Loc. Mit.', 'Prov. Mit.', 'Naz. Mit.', 'Rag. Soc. Des.', 'Ind. Des.',
							'Loc. Des.', 'Prov. Des.', 'Naz. Des.', 'N.ro Colli', 'Peso Kg.', 'Volume mc', 'Contrassegno', 'CAP Mittente', 'CAP Destinatario'];
      dati.push(intestazione)
      this.itemsVisualizzati.forEach(e => {
        var riga = []
        riga.push(e.codiceVisualizzato)
        riga.push(e.dataSpedizione)
        riga.push(e.codiceCliente)
        riga.push(e.noteStato)
        riga.push(e.dataStato)
        riga.push(e.riferimentoCliente)
        riga.push(e.ragioneSocialeMittente)
        riga.push(e.indirizzoMittente)
        riga.push(e.localitaMittente)
        riga.push(e.provinciaMittente)
        riga.push(e.nazioneMittente)
        riga.push(e.ragioneSocialeDestinatario)
        riga.push(e.indirizzoDestinatario)
        riga.push(e.localitaDestinatario)
        riga.push(e.provinciaDestinatario)
        riga.push(e.nazioneDestinatario)
        riga.push(e.numeroColli)
        riga.push(e.peso)
        riga.push(e.volume)
        riga.push(e.valContrassegno)
        riga.push(e.capMittente)
        riga.push(e.capDestinatario)
        dati.push(riga)
      })
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        var decodedString = dati.map(e => e.join(';')).join('\n');
        var byteCharacters = decodedString;
        var byteNumbers = new Array(byteCharacters.length);
        for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
        var byteArray = new Uint8Array(byteNumbers);
        var blob = new Blob([byteArray], {
            type: 'image/jpg'
        });
        navigator.msSaveBlob(blob, "Estrazione_Tracking.csv");
      }
      else{
        let csvContent = "data:text/csv;charset=utf-8," + dati.map(e => e.join(';')).join('\n');
        var encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "export.csv");
        link.click();
      }
    },
    formReset(){
      this.itemsVisualizzati = [];
      this.items = [];
      this.$refs.form.reset();
      this.annoSpe = new Date().toISOString().substr(0, 4);
      this.statoSelezionato = "TUTTI";
      this.portoSelezionato = "TUTTI";
      this.nazioneSelezionata = "TUTTI";
      this.nazione={value: "TUTTI", text: "TUTTI"};
      this.Stati={value: "TUTTI", text: "TUTTI"};
      this.porti={value: "TUTTI", text: "TUTTI"};
      this.erroreValidazione = false;
      
    },
    EstraiImmagini(e) {
      this.indice = 0;
      let imgContent = "data:mime/" + e.estensione + ";base64," + e.src;
      var encodedUri = encodeURI(imgContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", e.nomeFile + e.estensione);
      link.click();
    },
    
  }
};
</script>